<template>
    <div class="bg-gray-900 py-4 text-white">
        <div class="container mx-auto px-6 max-w-7xl flex flex-col md:flex-row justify-between items-center text-sm">
            <div class="mb-2 md:mb-0">
                &copy; 2025 {{ enterprise.name }}. Todos os direitos reservados.
            </div>
            <div class="flex items-center space-x-4">
                <span>Desenvolvido por guitecnology</span>
                <a href="https://www.instagram.com/guitecnology" target="_blank"
                    class="text-white hover:text-gray-400 transition-colors duration-300">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
                        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                    </svg>
                </a>
            </div>
        </div>
    </div>
</template>

<script setup>
import api from '@/services/api';
import { inject, ref } from 'vue';

const ENTERPRISE_KEY = 'enterpriseData';
const enterpriseData = inject(ENTERPRISE_KEY, ref({}));
const enterprise = enterpriseData;


</script>

<style scoped></style>